// Single source of truth for the app navigation, shared by the desktop
// SidePanel and the mobile floating menu (MobileNavMenu) so they can't drift.

export interface NavMenuItem {
  to: { name: string };
  icon: string;
  text: string;
  beta?: boolean;
}

export const navMenuItems: NavMenuItem[] = [
  {
    to: { name: 'sale-orders' },
    icon: 'fa-solid fa-dollar-sign',
    text: 'RFQs',
  },
  {
    to: { name: 'search' },
    icon: 'fa-solid fa-search',
    text: 'History Search',
  },
  {
    to: { name: 'price-lists' },
    icon: 'fa-solid fa-list',
    text: 'Price Lists',
  },
  {
    to: { name: 'copper-price-calculator' },
    icon: 'fa-solid fa-calculator',
    text: 'Copper Price',
  },
];

// Child routes resolve to their parent flow's nav entry: SO details belongs
// to RFQs, the price-list form pages (new/edit) to Price Lists. Drives both
// nav highlighting and the navbar page title.
const parentNavTabByRoute: Record<string, string> = {
  'sale-order': 'sale-orders',
  'price-list-new': 'price-lists',
  'price-list-edit': 'price-lists',
};

export const getActiveNavTab = (routeName: unknown): unknown =>
  (typeof routeName === 'string' && parentNavTabByRoute[routeName]) || routeName;

// Current page name for the top navbar (desktop breadcrumb "Pricing Engine
// / RFQs"; phones show the name alone). Same source as the nav menus so the
// navbar, SidePanel and mobile menu labels can't drift. Empty string for
// routes without a nav entry (login, 404) — the navbar falls back to the
// plain brand.
export const getPageTitle = (routeName: unknown): string => {
  const activeTab = getActiveNavTab(routeName);
  return navMenuItems.find((item) => item.to.name === activeTab)?.text ?? '';
};
